import { Helmet } from 'react-helmet-async'

export default function Analytics() {
  const scriptText = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'G-SWW27EXYET');
  `
  return (
    <Helmet>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-SWW27EXYET"
      ></script>
      <script>{scriptText}</script>
    </Helmet>
  )
}
